const firebaseConfig = {
  apiKey: "AIzaSyAqlBn98cO9lCdtmNjZQEzzmFcAPhQo3O0",
  authDomain: "delicioumo.firebaseapp.com",
  projectId: "delicioumo",
  storageBucket: "delicioumo.appspot.com",
  messagingSenderId: "702116765093",
  appId: "1:702116765093:web:c13ca39d25b4cd311f9c4c",
};

export default firebaseConfig;